import React from 'react';
import { ToastContainer } from 'react-toastify'; //import Scss
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'react-credit-cards/lib/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'cleave.js/dist/addons/cleave-phone.in';
import 'react-credit-cards/es/styles-compiled.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ptBR from 'rsuite/locales/pt_BR';

import 'presentation/app/assets/scss/themes.scss';
import { PasswordResetFlowProvider } from 'presentation/app/contexts/PasswordResetFlowContext';

import { Router } from './main/routing';

import '@repo/ui/styles.css';
import 'rsuite/DateRangePicker/styles/index.css';
import { createSelector } from 'reselect';
// eslint-disable-next-line import-helpers/order-imports
import { useSelector } from 'react-redux';
import { CustomProvider } from 'rsuite';

function App() {
  const layout = createSelector(
    (state) => state.Layout,
    (layoutModeType) => layoutModeType.layoutModeType,
  );

  const layoutModeType = useSelector(layout);
  return (
    <CustomProvider theme={layoutModeType} locale={ptBR}>
      <PasswordResetFlowProvider>
        <React.Fragment>
          <ToastContainer />
          <Router />
        </React.Fragment>
      </PasswordResetFlowProvider>
    </CustomProvider>
  );
}

export default App;
